import { render } from "./ProductModelSettingsTooltip.vue?vue&type=template&id=4745791c&scoped=true"
import script from "./ProductModelSettingsTooltip.vue?vue&type=script&lang=js"
export * from "./ProductModelSettingsTooltip.vue?vue&type=script&lang=js"

import "./ProductModelSettingsTooltip.vue?vue&type=style&index=0&id=4745791c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4745791c"]])

export default __exports__